const biomarkerKeys = {
  panels: (patientId: string) => ['patient', patientId, 'panels'],
};

export { biomarkerKeys };
